import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

import { useUserStore } from 'stores/user';

interface IIntlMessagesProps {
    id: string;
    /** What the message interpolates: text, numbers, elements, or functions wrapping its tags (as react-intl takes them). */
    values?: Record<string, unknown>;
    whitespaceStart?: boolean;
    whitespaceEnd?: boolean;
    currencySymbol?: string;
}

const IntlMessages = ({ id, values = {}, whitespaceStart = false, whitespaceEnd = false, currencySymbol = 'N.A.' }: IIntlMessagesProps) => {
    const user = useUserStore((state) => state.user);
    let _currencySymbol = currencySymbol;
    if (user && user?.currency?.symbol) {
        _currencySymbol = user.currency.symbol;
    }

    const newValues = {
        ...values,
        CURRENCY_SYMBOL: _currencySymbol,
    };

    return (
        <>
            {whitespaceStart && ' '}
            <FormattedMessage id={id} values={newValues as ComponentProps<typeof FormattedMessage>['values']} />
            {whitespaceEnd && ' '}
        </>
    );
};

export default IntlMessages;
